import { Home } from "modules/general/routes/Home/Home";
import { KnowYourCustomer } from "modules/general/routes/KnowYourCustomer";
import { NotFound } from "modules/general/routes/NotFound";
import { TermsAndConditions } from "modules/general/routes/TermsAndConditions";
import { getPaymentScene } from "modules/payment/Payment.scene";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { getAuthScene } from "./modules/auth/Auth.scene";

class AppRouter extends React.Component {
  // Render
  public render() {
    return (
      <BrowserRouter>
        <Routes>
          {getAuthScene()}

          {getPaymentScene()}

          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />

          <Route path="/kyc" element={<KnowYourCustomer />} />

          <Route path="/" element={<Home />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default AppRouter;
